import {
  ImportJobsApi,
  FamiliesApi,
  ImportUploadRequest,
  ImportUploadResponse,
  ImportStatusResponse,
  ImportReportResponse
} from 'we-tree-api-client/v2';

import { getApiConfiguration } from '@/services/SessionService';
import { ApiResult, withApiSetup } from './apiWrapper';

/**
 * Wrapped GEDCOM imports API with standardized error handling
 */
class WrappedGedcomImportsApi {
  /**
   * Create a new GEDCOM import job
   */
  async createGedcomImport(
    familyId: string,
    uploadRequest: ImportUploadRequest
  ): Promise<ApiResult<ImportUploadResponse>> {
    return withApiSetup(
      (config) => new FamiliesApi(config),
      getApiConfiguration,
      (api) => api.createGedcomImport(familyId, uploadRequest)
    );
  }

  /**
   * Complete a GEDCOM import job to start processing
   */
  async completeGedcomImport(familyId: string, jobId: string): Promise<ApiResult<void>> {
    return withApiSetup(
      (config) => new FamiliesApi(config),
      getApiConfiguration,
      (api) => api.completeGedcomImport(familyId, jobId)
    );
  }

  /**
   * Get import status
   */
  async getImportStatus(jobId: string): Promise<ApiResult<ImportStatusResponse>> {
    return withApiSetup(
      (config) => new ImportJobsApi(config),
      getApiConfiguration,
      (api) => api.getImportStatus(jobId)
    );
  }

  /**
   * Get import report
   */
  async getImportReport(jobId: string): Promise<ApiResult<ImportReportResponse>> {
    return withApiSetup(
      (config) => new ImportJobsApi(config),
      getApiConfiguration,
      (api) => api.getImportReport(jobId)
    );
  }

  /**
   * Rollback an import
   */
  async rollbackImport(jobId: string): Promise<ApiResult<void>> {
    return withApiSetup(
      (config) => new ImportJobsApi(config),
      getApiConfiguration,
      (api) => api.rollbackImport(jobId)
    );
  }
}

/**
 * Wrapped GEDCOM imports API instance with standardized error handling
 */
export const gedcomImportsApi = new WrappedGedcomImportsApi();

export default gedcomImportsApi;
